module.exports = __webpack_public_path__ + "img/pleat_width.98b55e50.png";